import Image from '@components/Image';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { UserCouponResponse } from '@models/coupon';
import { useTranslation } from 'react-i18next';

interface Props {
    coupon: UserCouponResponse;
}

const getCouponStatusKey = (status: string): string => {
    const statusMap: Record<string, string> = {
        ISSUED: 'status.issued',
        USED: 'status.used',
        EXPIRED: 'status.expired',
        CANCELLED: 'status.cancelled',
    };
    return statusMap[status] || status;
};

function CouponImageCard({ coupon }:Props) {
    const { imageUrl, status } = coupon;
    const { t } = useTranslation('coupon');
    return (
        <Card>
            <ImageContainer>
                <Thumbnail src={imageUrl}
                    width={140}
                    height={140}
                    alt={t('detail.couponImageAlt')} />
                {status !== 'ISSUED' && (
                    <DisaledOverlay >
                        <Text size='body-long' fontWeight='bold' color={colors.gray7} align='center'>
                            {t(getCouponStatusKey(status))}
                        </Text>
                    </DisaledOverlay>
                )}
            </ImageContainer>
        </Card>
    );
}

const Card = styled.div`
    background-color: var(--color-primary);
    border-radius: var(--radius-sm);
    display: flex;
    justify-content: center;
    padding: var(--spacing-8) 62px;
`;

const ImageContainer = styled.div`
    align-items: center;
    background-color: var(--color-gray2);
    border-radius: var(--radius-full);
    display: flex;
    height: 140px;
    justify-content: center;
    overflow: hidden;
    position: relative;
    width: 140px;
`;

const Thumbnail = styled(Image)`
    height: 100%;
    object-fit: cover;
    width: 100%;
`;

const DisaledOverlay = styled.div`
    background: linear-gradient(0deg, rgba(196, 131, 114, 0.16) 0%, rgba(196, 131, 114, 0.16) 100%), rgba(255, 255, 255, 0.65);
    height: 25px;
    padding: 3px 0 2px;
    position: absolute;
    text-align: center;
    transform: rotate(-18.17deg);
    width: 88px;
`;

export default CouponImageCard;
